import { createContext, useContext, useEffect, useState } from "react";
import { fetchCategoryDetails } from "../apiServices/categoryPageServices";

const CategoryDetailsContext = createContext();

export const CategoryDetailsProvider = ({ children }) => {
  const [categoryDetailes, setCategoryDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Function to fetch category data by ID
  const loadCategoryData = async (categoryId, language) => {
    if (!categoryId) return;
    setLoading(true);
    try {
      const data = await fetchCategoryDetails(categoryId, language);
      if (data) setCategoryDetails(data);
      else throw new Error("No data received");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CategoryDetailsContext.Provider
      value={{ categoryDetailes, loading, error, loadCategoryData }}
    >
      {children}
    </CategoryDetailsContext.Provider>
  );
};

// Custom hook for easy access
export const useCategoryDetails = () => useContext(CategoryDetailsContext);
